import { useEffect } from 'react';
import { Center, Image } from '@chakra-ui/react';
import { Header } from '../../components/header/Header';
import { PageTitle } from '../../components/pageTitle/PageTitle';

import logo from '../../assets/images/soma-logo.png';
import { useAuthentication } from '../../hooks/useAuthentication';

export const Home = () => {
  return (
    <>
      <Header />
      <PageTitle title="Soma Consignados Ltda." />
      <Center height='40vh'>
        <Image src={ logo } alt='logo da empresa' mt={200} width={900} />
      </Center>
    </>
  );
}
